'use client';

import { TranslationSnapshotProvider } from '@eliadmin/core/src/i18n/translation-context';
import type { PropsWithChildren } from 'react';
import { GENERATED_TRANSLATIONS } from '../dictionaries/dictionary-ad4fb37537f2c8558384d250726a2d8bdf6e08894930d776f7a5c4858e327b7c';

export default function GeneratedLocaleTranslationBoundary({ children }: PropsWithChildren) {
  return (
    <TranslationSnapshotProvider translations={GENERATED_TRANSLATIONS}>
      {children}
    </TranslationSnapshotProvider>
  );
}
